import { type ReactNode } from 'react'

interface CardProps {
  children: ReactNode
  className?: string
  padding?: 'none' | 'sm' | 'md' | 'lg'
}

export function Card({ children, className = '', padding = 'md' }: CardProps) {
  const paddingStyles = {
    none: '',
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8',
  }

  return (
    <div
      // eslint-disable-next-line security/detect-object-injection
      className={`bg-white dark:bg-gray-800 shadow rounded-lg ${paddingStyles[padding]} ${className}`}
    >
      {children}
    </div>
  )
}
